import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { handleQuerySuccess } from '../../../../hooks/useQuriesSuccess';
import { apiRequest } from './../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import useDeleteMutation from '../../../../hooks/apis/useDeleteMutaion';
import useSaveMutation from '../../../../hooks/apis/useSaveMutaion';
import { mapParamsBySchema, mapRowsBySchema } from '../../../../util';
import { TRA_CUSTOM_02_Schema } from './TRA_CUSTOM_02_Schema';
import useSearchMutaion from '../../../../hooks/apis/useSearchMutaion';

export const useSearchCode = (options = {}) => {
  const { onSuccess } = options;

  const query = useQuery({
    queryKey: ['Utility', 'getCodeInfo'],
    queryFn: () => apiRequest('post', Global.urls.Utility.getCodeInfo),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(TRA_CUSTOM_02_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['Training', 'getTraCustom02R1', params],
    queryFn: () =>
      apiRequest('post', Global.urls.Training.getTraCustom02R1, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

export const useSearch2 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      TRA_CUSTOM_02_Schema.mapper.search2,
      context
    );
    return apiRequest('post', Global.urls.Training.getTraCustom02R2, params);
  }, successOptions);
};

export const useSearch3 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      TRA_CUSTOM_02_Schema.mapper.search3,
      context
    );
    return apiRequest('post', Global.urls.Member.getMemBasicR1, params);
  }, successOptions);
};

export const useSave1 = (options = {}) => {
  return useSaveMutation(async ({ rows, isEtcEduType }) => {
    const payload = mapRowsBySchema(rows, TRA_CUSTOM_02_Schema.mapper.save1, {
      isEtcEduType,
    });

    return apiRequest('post1', Global.urls.Training.saveTraCustom02U1, payload);
  }, options);
};

export const useSave2 = (options = {}) => {
  return useSaveMutation(async ({ rows, tpmId }) => {
    const payload = mapRowsBySchema(rows, TRA_CUSTOM_02_Schema.mapper.save2, {
      tpmId,
    });
    return apiRequest('post1', Global.urls.Training.saveTraCustom02U2, payload);
  }, options);
};

export const useDelete1 = (options = {}) => {
  return useDeleteMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, TRA_CUSTOM_02_Schema.mapper.delete1);
    return apiRequest(
      'post1',
      Global.urls.Training.deleteTraCustom02D1,
      payload
    );
  }, options);
};
export const useDelete2 = (options = {}) => {
  return useDeleteMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, TRA_CUSTOM_02_Schema.mapper.delete2);
    return apiRequest(
      'post1',
      Global.urls.Training.deleteTraCustom02D2,
      payload
    );
  }, options);
};

/** QR 임시 세션 생성 (저장 전). context: { expireHours?, search, userInfo } */
export const useCreateTraCustom02QrSession = (options = {}) => {
  return useSaveMutation(async (context) => {
    const payload = mapParamsBySchema(
      TRA_CUSTOM_02_Schema.mapper.qrSessionCreate,
      context
    );
    return apiRequest(
      'post',
      Global.urls.Training.createTraCustom02QrSession,
      payload
    );
  }, options);
};

/** QR 세션별 임시 참석 명단 조회 (폴링). context: { sessionId } */
export const useSearchTraCustom02SessionR2 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      TRA_CUSTOM_02_Schema.mapper.qrSessionPoll,
      context
    );
    return apiRequest(
      'post',
      Global.urls.Training.getTraCustom02SessionR2,
      params
    );
  }, successOptions);
};

/** 세션 명단을 교육일지(tpmId)에 반영. context: { sessionId, tpmId } */
export const useBindTraCustom02QrSession = (options = {}) => {
  return useSaveMutation(async (context) => {
    const payload = mapParamsBySchema(
      TRA_CUSTOM_02_Schema.mapper.qrSessionBind,
      context
    );
    return apiRequest(
      'post',
      Global.urls.Training.bindTraCustom02QrSession,
      payload
    );
  }, options);
};

/**
 * 결재 반려 저장
 * context: { row: { tpmId, returnDetail }, userInfo }
 */
export const saveTraCustom02ApproverReject = async (context) => {
  const row = context?.row ?? null;
  const params = mapRowsBySchema(
    row ? [row] : [],
    TRA_CUSTOM_02_Schema.mapper.approverReject,
    context
  )?.[0];
  return apiRequest(
    'post',
    Global.urls.Training.saveTraCustom02ApproverReject,
    params
  );
};

/**
 * 결재 서명 저장 (중간/최종 결재자)
 * context: { row: { tpmId, signPath }, userInfo }
 */
export const saveTraCustom02ApproverSign = async (context) => {
  const row = context?.row ?? null;
  const params = mapRowsBySchema(
    row ? [row] : [],
    TRA_CUSTOM_02_Schema.mapper.approverSign,
    context
  )?.[0];
  return apiRequest(
    'post',
    Global.urls.Training.saveTraCustom02ApproverSign,
    params
  );
};

/**
 * 반려 이력 조회
 * context: { row: { tpmId } }
 */
export const getTraCustom02ReturnHistory = async (context) => {
  const row = context?.row ?? null;
  const params = mapRowsBySchema(
    row ? [row] : [],
    TRA_CUSTOM_02_Schema.mapper.returnHistory,
    context
  )?.[0];
  return apiRequest(
    'post',
    Global.urls.Training.getTraCustom02ReturnHistory,
    params
  );
};
